export enum SubmissionStatusNumericEnum {
  readyForApproval = 1,
  submissionApproved,
  submissionRejected,
  submissionInProcess,
  submissionFailed,
  pendingModelRegistration,
  replaced,
  haSystemError,
  invalidCredentials,
  internalSystemError,
  submissionPassed,
  hungRecord
}


